import React, { useEffect } from 'react';
import "./index.less"
import Progress from "../../../images/aiReport/progress.png"

const Schedule = (props) => {
    const { percent = 0, percentText = '' } = props;
    useEffect(() => {
        drawCircle();
    },[percent])

    const drawCircle = () => {
        let canvas = document.getElementById('tutorial1');
        let ctx = canvas.getContext('2d');
        let ratio = 3;
        let _percent = Math.ceil(percent*0.75) > 75 ? 75 : Math.ceil(percent*0.75);
        let obj = {
            width: 122*ratio,
            height: 122*ratio,
            dx: 5*ratio, // 刻度宽度
            dy: 1*ratio, // 刻度高度
            num: 80, // 刻度条数
            r: 52*ratio, // 半径
            start: -90, // 开始角度，与结束角度相对称
            progress: _percent, // 显示进度 （单位百分比）
            index: 0, // 开始刻度
            defaultColor: '#dee1e4', // 开始颜色
            activeColor: '#5473FF', // 进度条颜色
            colorList: [
                '#5473FF', '#5473FF', '#5473FF', '#5473FF','#5473FF', '#5473FF',
                '#5473FF', '#5473FF', '#5473FF', '#5473FF','#5473FF', '#5473FF',
                '#5473FF', '#5473FF', '#5473FF', '#5473FF', '#5473FF', '#5473FF',
                '#5473FF', '#5473FF', '#5473FF', '#5473FF', '#5473FF', '#5473FF',
                '#5473FF', '#5473FF', '#5473FF', '#616EFF', '#7268FF', '#7765FF',
                '#7D63FF', '#8360FF', '#895FFF', '#8E5CFF', '#9858FF', '#9D57FF',
                '#A155FF', '#A654FF', '#A952FF', '#AC51FF', '#B050FF ', '#B34FFF',
                '#B44DFF', '#BB4BFF', '#BB4BFF', '#BB4BFF', '#BB4BFF', '#BB4BFF',
                '#BB4BFF', '#BB4BFF', '#BB4BFF', '#BB4BFF', '#BB4BFF', '#BB4BFF',
                '#BB4BFF', '#BB4BFF', '#BB4BFF', '#BB4BFF','#BB4BFF', '#BB4BFF',
                '#BB4BFF', '#BB4BFF','#BB4BFF', '#BB4BFF', '#BB4BFF','#BB4BFF',
                '#BB4BFF', '#BB4BFF', '#BB4BFF',],
        };
        obj.deg = (180 - 2 * obj.start) / obj.num;
        canvas.width = obj.width;
        canvas.height = obj.height;

        function draw(x, color, last) { // 画出环形刻度线
            ctx.save();
            let deg = Math.PI / 180 * (obj.start + obj.deg * x); // 角度换算弧度
            let offsetY = -(Math.sin(deg) * obj.r); // 计算刻度Y轴位置
            let offsetX = -(Math.cos(deg) * obj.r); // 计算刻度X轴位置
            ctx.fillStyle = color;
            ctx.translate(obj.width / 2 - offsetX, obj.height / 2 - offsetY); // 修改画布坐标原点
            ctx.rotate(deg); // 旋转刻度
            ctx.fillRect(last ? -10*ratio : 0, 0, last ? 16*ratio : obj.dx, obj.dy); // 画出刻度
            ctx.fillRect(last ? -10*ratio : 0, 0, last ? 16*ratio : obj.dx, obj.dy);
            ctx.restore();
        }

        function animate(s, time, last) {
            if (obj.progress == 0) { // 进度为0直接退出函数
                return false;
            }

            draw(s, obj.colorList[s], last);

            let num = obj.progress * (obj.num / 100) - 2; //格数计算
            num = Math.floor(num);

            let timmer = setTimeout(function () {
                obj.index = s + 1;
                if (s >= num) {
                    clearTimeout(timmer);
                } else {
                    animate(obj.index, time, obj.index === num);
                }
            }, time)
        }
        animate(obj.index, 0)

    }

    return (
        <div class="ring">
            <img src={Progress} className="tutorial"/>
            <canvas id="tutorial1" style={{width: 120, height: 120}}></canvas>
            <div className="userEchart-cont">
                <p>{percent || 0}<span>%</span></p>
                <p>{percentText}</p>
            </div>
        </div>
    )
};

export default Schedule;